export default function(angle) {
  return ((angle - 90) * Math.PI) / 180.0;
}
